import { RSAA } from 'redux-api-middleware';
import { withAuth } from '../reducers'
import {URL_API,DEP_SUCCESS,DEP_REQUEST,DEP_FAILURE,DEP_CLEAR} from "../constants";



export function fetchSuccessDepartament(items){
    return {
        type: DEP_SUCCESS,
        items
    }
}

export function departamentClear() {
    return {
        type: DEP_CLEAR
    }
}

export const fetchDataDepartament = (val) => {
    return {
        [RSAA]: {
            endpoint: `${URL_API}/dep/?search=${val}`,
            method: 'GET',
            headers: withAuth({ 'Content-Type': 'application/json' }),
            types: [DEP_REQUEST, DEP_SUCCESS,DEP_FAILURE]
        }

    }
}



// WEBPACK FOOTER //
// ./src/actions/departament.js